import React from "react";
import USPSection2Cards from "../USPSection2/USPSection2Cards";
import { Row, Col } from "react-bootstrap";
import Icon1 from "../../assets/images/USPIcons/check-mark.png";
import Icon2 from "../../assets/images/USPIcons/loupe.png";
import Icon3 from "../../assets/images/USPIcons/no-preservatives.png";
import Icon4 from "../../assets/images/USPIcons/ecology.png";
import Icon5 from "../../assets/images/USPIcons/moisture-wicking-fabric.png";
import Icon6 from "../../assets/images/USPIcons/organic.png";
import BestPrice from "../../assets/images/benefits/best-price.svg";
import Traceability from "../../assets/images/benefits/traceability.svg";

const ManufacturerBenefits = () => {
  const benefits = [

    
    {
      image: Icon2,
      title: "Origin Authenticity",
      bodycopy:
        "ApisChain ensures the origin authenticity of its honey through traceability and unwavering commitment to quality.        ",
    },
    {
      image: Icon3,
      title: "Chemical Preservative free honey",
      bodycopy:
        "ApisChain offers chemical preservative-free honey, ensuring pure and natural goodness in every drop.        ",
    },
    {
      image: Icon4,
      title:"Sustainably Produced",
      bodycopy:
        "ApisChain's honey is produced sustainably through practices such as organic beekeeping, habitat preservation, and minimal hive disturbance.        ",
    },
    {
      image: Icon5,
      title: "Moisture free honey ",
      bodycopy:
        "Our honey is carefully processed to be moisture-free, ensuring superior quality and extended shelf life for customers.        ",
    },

    {
      image: Icon6,
      title: "Organic honey ",
      bodycopy:
        "Experience the pure and natural goodness of our organic honey, sourced and produced with utmost care.        ",
    },

    {
      title: "Quality Assurance",
      bodycopy:
        "ApisChain ensures product consistency, safety, and compliance with industry standards and regulatory requirements, minimizing risks and maintaining high-quality production. ",
      image: Icon1,
    },
    {
      title: "Farm Process Traceability",
      bodycopy:
        "ApisChain tracks farming practices from seed to harvest, ensuring transparency, quality, and consumer trust.        ",
      image: Traceability,
    }, 
   
    {
      title: "Best Price",
      bodycopy:
        "Buyer benefit from securing the best price through optimized sourcing and bulk purchasing, ensuring cost savings and maximizing profitability.",
      image: BestPrice,
    },
  ];
  return (
    <>
      <Row>
        {benefits.map((e, index) => {
          return (
            <Col md={4} key={index}>
              <USPSection2Cards
                cardtitle={e.title}
                src={e.image}
                cardBodycopy={e.bodycopy}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default ManufacturerBenefits;
